<script>
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import Vue from 'vue'

export default {
  components: { Title },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      step: 0,
      items: [0, 1, 2, 3],
      dontShowAgain: false,
    }
  },
  created() {
    GlobalBus.$on(MODAL.RELEASE_NOTES_CLIENTE, this.open)
    this.busModal.$on('close', this.onClose)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.RELEASE_NOTES_CLIENTE, this.open)
    if (this.busModal) {
      this.busModal.$off('close', this.onClose)
    }
  },
  methods: {
    open() {
      if (this.$currentUser().IS_CLIENTE) {
        this.busModal.$emit('dialog', true)
      }
    },
    onClose() {
      this.$store.dispatch('parameters/saveConfigLocal', {
        showModalUpdates: !this.dontShowAgain,
      })
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900px" center-screen>
    <Title title="Atualização" />
    <div>
      <v-carousel v-model="step" height="450">
        <v-carousel-item>
          <div
            class="d-flex align-items-center justify-content-center"
            style="height: 100%"
          >
            <div style="width: 80%; margin-bottom: 20vh">
              <p> Olá! </p>
              <p>
                De forma a melhorar a usabilidade e sua experiência com a
                plataforma, o layout da plataforma mudou!
              </p>
              <p>
                Passe ao lado para ver os detalhes
                <v-icon color="black"> mdi-arrow-right </v-icon>
              </p>
            </div>
          </div>
        </v-carousel-item>
        <v-carousel-item>
          <div
            class="d-flex align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              style="width: 80%; margin-bottom: 10vh"
              class="d-flex justify-content-between"
            >
              <div style="width: 30%">
                <v-img
                  src="https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/Imagem4.png"
                  max-height="300"
                  contain
                ></v-img>
              </div>
              <div style="width: 60%">
                <p class="subtitle"> NAVEGAÇÃO ENTRE TELAS </p>
                <p>
                  Agora você consegue navegar entre telas pela aba lateral
                  esquerda e utilizar funções independentemente de onde você
                  estiver no sistema, via gatilhos rápidos - imagem ao lado.
                </p>
                <p>
                  Por exemplo, consigo cadastrar um ativo, vincular uma conta de
                  investimento, a partir de qualquer tela. Assim como atualizar
                  a rentabilidade da sua carteira realizar um processo de
                  portabilidade de ativos, etc.
                </p>
              </div>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>

    <v-checkbox v-model="dontShowAgain" label="Não mostrar isso novamente" />

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Sair </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>
